import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isClient, isServer } from "../../utils/ssr.utils/index.js";
import localForage from "../../plugins/localforage/index.js";
var storage = isClient() ?
// actual indexedDB storage for client
localForage :
// indexedDB storage mock for SSR
{
  getItem: function getItem() {
    return Promise.resolve(null);
  },
  setItem: function setItem(_, val) {
    return Promise.resolve(val);
  },
  removeItem: function removeItem() {
    return Promise.resolve(null);
  },
  clear: function clear() {
    return Promise.resolve(null);
  }
};
export var $storage = {
  /**
   * get item from storage
   * @param {string} key - return JSON parsed value of a key
   * @return {*} - return JSON parsed value of a key
   */
  get: function get(key) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var value;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return storage.getItem(key);
          case 2:
            value = _context.sent;
            if (!isServer()) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", value);
          case 5:
            _context.prev = 5;
            return _context.abrupt("return", JSON.parse(value));
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", value);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 9]]);
    }))();
  },
  /**
   * set/update a key
   * @param {string} key
   * @param {*} val
   */
  set: function set(key, val) {
    if (isServer()) {
      return storage.setItem(key, val);
    }
    var value = typeof val === 'object' ? JSON.stringify(val) : val;
    return storage.setItem(key, value);
  },
  /**
   * Remove item based on key
   * @param {string} key
   */
  remove: function remove(key) {
    return storage.removeItem(key);
  },
  /**
   * clear the storage
   */
  clear: function clear() {
    return storage.clear();
  }
};